import React, { useState, useEffect, useRef } from 'react';

const ValuesSelection = () => {
  // Initial values data
  const initialValuesByCategory = {
    'A-C': [
      'Abundance', 'Acceptance', 'Accessibility', 'Accomplishment', 'Accountability', 
      'Accuracy', 'Achievement', 'Adaptability', 'Admiration', 'Adventure',
      'Affection', 'Agility', 'Altruism', 'Ambition', 'Amusement', 'Appreciation', 
      'Approachability', 'Assertiveness', 'Attentiveness', 'Attraction', 'Authenticity', 
      'Authority', 'Autonomy', 'Availability', 'Awareness', 'Balance', 'Beauty', 
      'Belonging', 'Boldness', 'Bravery', 'Brilliance', 'Calm', 'Candor', 'Capable', 
      'Careful', 'Carefulness', 'Caring', 'Celebration', 'Certainty', 'Challenge', 
      'Change', 'Character', 'Charity', 'Cheerfulness', 'Clarity', 'Collaboration', 
      'Comfort', 'Commitment', 'Communication', 'Community', 'Compassion', 
      'Competence', 'Competition', 'Confidence', 'Connection', 'Conscientious', 
      'Consistency', 'Contentment', 'Contribution', 'Control', 'Conviction', 
      'Cooperation', 'Correctness', 'Courage', 'Courtesy', 'Creativity', 'Credibility', 
      'Curiosity'
    ],
    'D-H': [
      'Daring', 'Decency', 'Decisive', 'Dedication', 'Defend', 'Delight', 'Democratic', 
      'Dependability', 'Desire', 'Determination', 'Development', 'Devotion', 'Dignity', 
      'Diligence', 'Directness', 'Discipline', 'Discovery', 'Diversity', 'Dreaming', 
      'Drive', 'Duty', 'Eagerness', 'Education', 'Effectiveness', 'Efficiency', 
      'Egalitarian', 'Elegance', 'Empathy', 'Empowering', 'Encouragement', 'Endurance', 
      'Energy', 'Engagement', 'Enjoyment', 'Entertainment', 'Enthusiasm', 'Entrepreneurship', 
      'Equality', 'Ethical', 'Excellence', 'Excitement', 'Experience', 'Experimentation', 
      'Expertise', 'Exploration', 'Expressive', 'Exuberance', 'Fairness', 'Faith', 
      'Faithfulness', 'Fame', 'Family', 'Fearless', 'Ferocious', 'Flair', 'Flexibility', 
      'Focus', 'Foresight', 'Fortitude', 'Freedom', 'Friendship', 'Frugality', 'Fun', 
      'Generosity', 'Genuine', 'Giving', 'Goodness', 'Grace', 'Gratitude', 'Growth', 
      'Guidance', 'Happiness', 'Harmony', 'Health', 'Helping', 'Honesty', 'Honor', 
      'Hope', 'Hopeful', 'Hospitality', 'Humility'
    ],
    'I-Q': [
      'Imagination', 'Impact', 'Improvement', 'Inclusion', 'Independence', 'Individuality', 
      'Industrious', 'Influence', 'Ingenuity', 'Innovation', 'Inquisitive', 'Insight', 
      'Inspiration', 'Integrity', 'Intelligence', 'Interdependence', 'Intuition', 
      'Inviting', 'Irreverence', 'Joy', 'Justice', 'Kindness', 'Knowledge', 'Leadership', 
      'Learning', 'Local', 'Logic', 'Love', 'Loyalty', 'Mastery', 'Maturity', 
      'Meaning', 'Merit', 'Meticulousness', 'Moderation', 'Modesty', 'Motivation', 
      'Mystery', 'Nimble', 'Nurturing', 'Openness', 'Optimism', 'Order', 'Organisation', 
      'Originality', 'Ownership', 'Passion', 'Patience', 'Peace', 'Perception', 
      'Performance', 'Persistence', 'Play', 'Pleasure', 'Poise', 'Popularity', 
      'Positivity', 'Potential', 'Power', 'Practical', 'Pragmatic', 'Precision', 
      'Preservation', 'Pride', 'Proactive', 'Productivity', 'Professionalism', 
      'Progress', 'Prosperity', 'Prudence', 'Purpose', 'Quality'
    ],
    'R-Z': [
      'Rational', 'Realistic', 'Reason', 'Recognition', 'Reflection', 'Relaxation', 
      'Reliable', 'Renewal', 'Resilience', 'Resolve', 'Resourcefulness', 'Respect', 
      'Responsibility', 'Rest', 'Restraint', 'Results', 'Rigor', 'Risk', 'Safety', 
      'Satisfaction', 'Savvy', 'Security', 'Self-reliance', 'Selflessness', 'Sensitivity', 
      'Serenity', 'Service', 'Sharing', 'Significance', 'Silliness', 'Simplicity', 
      'Sincerity', 'Skill', 'Solitude', 'Speed', 'Spirituality', 'Spontaneous', 
      'Stability', 'Status', 'Stewardship', 'Strength', 'Structure', 'Success', 
      'Support', 'Surprise', 'Sustainability', 'Synergy', 'Teamwork', 'Temperance', 
      'Tenderness', 'Thorough', 'Thoughtful', 'Timeliness', 'Togetherness', 'Tolerance', 
      'Toughness', 'Tradition', 'Training', 'Tranquility', 'Transparency', 'Trust', 
      'Truth', 'Understanding', 'Uniqueness', 'Unity', 'Variety', 'Versatility', 
      'Victory', 'Virtue', 'Vision', 'Vitality', 'Warmth', 'Wealth', 'Weirdness', 
      'Welcoming', 'Wellbeing', 'Willpower', 'Winning', 'Wisdom', 'Wonder', 'Zest'
    ]
  };

  // State for values by category
  const [valuesByCategory, setValuesByCategory] = useState({...initialValuesByCategory});
  
  // State for current step, selected values and grouped values
  const [step, setStep] = useState(1);
  const [selectedValues, setSelectedValues] = useState({});
  const [valueGroups, setValueGroups] = useState([
    { name: 'Group 1', values: [] },
    { name: 'Group 2', values: [] },
    { name: 'Group 3', values: [] }
  ]);
  const [ungroupedValues, setUngroupedValues] = useState([]);
  const [customValue, setCustomValue] = useState('');
  
  // Ref for the section element to control scrolling
  const sectionRef = useRef(null);
  
  // Ref to track initial render
  const initialRender = useRef(true);

  // Track previous step value to detect actual step changes
  const prevStepRef = useRef(1);
  
  // Effect to scroll to top of section only when step actually changes
  useEffect(() => {
    // Only scroll if the step has actually changed and not on initial render
    if (initialRender.current) {
      initialRender.current = false;
    } else if (prevStepRef.current !== step && sectionRef.current) {
      // Scroll the section element to the top
      sectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    
    // Update the previous step value
    prevStepRef.current = step;
  }, [step]);

  // Toggle value selection
  const toggleValueSelection = (value) => {
    setSelectedValues(prev => ({
      ...prev,
      [value]: !prev[value]
    }));
  };

  const addCustomValue = () => {
    if (customValue.trim() !== '') {
      // Add to relevant category based on first letter
      const firstLetter = customValue.trim()[0].toUpperCase();
      let category = 'A-C';
      
      if (firstLetter >= 'D' && firstLetter <= 'H') category = 'D-H';
      else if (firstLetter >= 'I' && firstLetter <= 'Q') category = 'I-Q';
      else if (firstLetter >= 'R' && firstLetter <= 'Z') category = 'R-Z';
      
      // Update the valuesByCategory state - insert alphabetically
      setValuesByCategory(prev => {
        const newValuesByCategory = {...prev};
        
        // Add the value to the array
        newValuesByCategory[category] = [...newValuesByCategory[category], customValue.trim()];
        
        // Sort the array alphabetically
        newValuesByCategory[category].sort((a, b) => a.localeCompare(b));
        
        return newValuesByCategory;
      });
      
      // Mark the new value as selected
      setSelectedValues(prev => ({
        ...prev,
        [customValue.trim()]: true
      }));
      
      setCustomValue('');
    }
  };

  // Navigate to a specific step
  const navigateToStep = (newStep) => {
    if (newStep === 2) {
      // When going to step 2, only populate ungrouped values with values 
      // that are selected but not yet in any group
      const selectedValuesList = Object.keys(selectedValues).filter(value => selectedValues[value]);
      
      // Get all values that are already in groups
      const groupedValues = valueGroups.flatMap(group => group.values);
      
      // Set ungrouped values to only those selected values that aren't in any group
      const newUngroupedValues = selectedValuesList.filter(value => !groupedValues.includes(value));
      setUngroupedValues(newUngroupedValues);
    }
    setStep(newStep);
  };

  // Add a value to a group
  const addToGroup = (groupIndex, value) => {
    // Add to the specified group
    setValueGroups(prev => {
      const newGroups = [...prev];
      if (!newGroups[groupIndex].values.includes(value)) {
        newGroups[groupIndex] = {
          ...newGroups[groupIndex],
          values: [...newGroups[groupIndex].values, value]
        };
      }
      return newGroups;
    });
    
    // Remove from ungrouped values
    setUngroupedValues(prev => prev.filter(v => v !== value));
  };

  // Remove value from a group
  const removeFromGroup = (groupIndex, value) => {
    // Remove from the group
    setValueGroups(prev => {
      const newGroups = [...prev];
      newGroups[groupIndex] = {
        ...newGroups[groupIndex],
        values: newGroups[groupIndex].values.filter(v => v !== value)
      };
      return newGroups;
    });
    
    // Add back to ungrouped values
    setUngroupedValues(prev => {
      if (!prev.includes(value)) {
        return [...prev, value];
      }
      return prev;
    });
  };

  // Update group name
  const updateGroupName = (index, newName) => {
    setValueGroups(prev => {
      const newGroups = [...prev];
      newGroups[index] = {
        ...newGroups[index],
        name: newName
      };
      return newGroups;
    });
  };

  // Add a new group
  const addGroup = () => {
    const newGroupNumber = valueGroups.length + 1;
    setValueGroups(prev => [...prev, { name: `Group ${newGroupNumber}`, values: [] }]);
  };

  return (
    <section className="values-selection" ref={sectionRef}>
      <h2 className="section-title">Identify Your Core Values</h2>
      
      {/* Step navigation */}
      <div className="step-navigation">
        <button 
          onClick={() => navigateToStep(1)} 
          className={`step-button ${step === 1 ? 'active' : ''}`}
        >
          Step 1: Select Values
        </button>
        <button 
          onClick={() => navigateToStep(2)} 
          className={`step-button ${step === 2 ? 'active' : ''}`}
          disabled={Object.keys(selectedValues).filter(value => selectedValues[value]).length === 0}
        >
          Step 2: Group Values
        </button>
        <button 
          onClick={() => navigateToStep(3)} 
          className={`step-button ${step === 3 ? 'active' : ''}`}
          disabled={valueGroups.every(group => group.values.length === 0)}
        >
          Step 3: Summary
        </button>
      </div>
      
      {step === 1 && (
        <div className="section-card">
          <h3 className="step-title">Step 1: First pass of core values</h3>
          <p className="step-instruction">
            Use the list below to pick values that resonate - simply tick the 'select' checkbox to include. 
            Don't over think this step too much. You can cut back later.
            Make this list your own! You can also add your own values in the field below.
          </p>
          
          <div className="custom-value-form">
            <input
              type="text"
              value={customValue}
              onChange={(e) => setCustomValue(e.target.value)}
              placeholder="Add a custom value..."
              className="custom-value-input"
            />
            <button 
              onClick={addCustomValue}
              className="custom-value-button"
            >
              Add
            </button>
          </div>
          
          <div className="values-categories">
            {Object.entries(valuesByCategory).map(([category, values]) => (
              <div key={category} className="values-category">
                <h4 className="category-title">{category}</h4>
                <div className="values-list">
                  {values.map((value, index) => (
                    <div key={`${value}-${index}`} className="value-item">
                      <label className="value-label">
                        <input
                          type="checkbox"
                          checked={selectedValues[value] || false}
                          onChange={() => toggleValueSelection(value)}
                          className="value-checkbox"
                        />
                        <span className="value-text">{value}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          
          <button 
            onClick={() => navigateToStep(2)}
            className="continue-button"
            disabled={Object.keys(selectedValues).filter(value => selectedValues[value]).length === 0}
          >
            Continue to Step 2
          </button>
        </div>
      )}
      
      {step === 2 && (
        <div className="section-card">
          <h3 className="step-title">Step 2: Group values</h3>
          <p className="step-instruction">
            In this step it's time to group the values you selected around common themes. Let's say you picked 'training', 'skill', 'curiosity' and 'education.' You could group these values together under the common theme of 'learning.'
          </p>
          
          <div className="grouping-container">
            <div className="value-groups">
              <h3>Groups</h3>
              {valueGroups.map((group, index) => (
                <div key={index} className="value-group">
                  <input
                    type="text"
                    value={group.name}
                    onChange={(e) => updateGroupName(index, e.target.value)}
                    className="group-name-input"
                    placeholder="Group theme name"
                  />
                  <div className="grouped-values">
                    {group.values.map((value, valueIndex) => (
                      <div key={valueIndex} className="grouped-value-item">
                        {value}
                        <button 
                          onClick={() => removeFromGroup(index, value)}
                          className="remove-from-group-button"
                          aria-label={`Remove ${value} from ${group.name}`}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                    {group.values.length === 0 && (
                      <div className="empty-group-placeholder">
                        Add values here
                      </div>
                    )}
                  </div>
                </div>
              ))}
              
              <button 
                onClick={addGroup}
                className="add-group-button"
              >
                + Add Another Group
              </button>
            </div>
            <div className="ungrouped-values">
              <h3>Values to Group</h3>
              <div className="values-pool">
                {ungroupedValues.length > 0 ? (
                  ungroupedValues.map((value, index) => (
                    <div key={index} className="ungrouped-value-item">
                      {value}
                      <div className="group-selectors">
                        {valueGroups.map((group, groupIndex) => (
                          <button 
                            key={groupIndex}
                            onClick={() => addToGroup(groupIndex, value)}
                            className="add-to-group-button"
                          >
                            Add to {group.name}
                          </button>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="empty-pool-message">
                    All values have been grouped!
                  </div>
                )}
              </div>
            </div>
          </div>
          
          <div className="navigation-buttons">
            <button 
              onClick={() => navigateToStep(1)}
              className="back-button"
            >
              Back to Step 1
            </button>
            <button 
              onClick={() => navigateToStep(3)}
              className="continue-button"
              disabled={valueGroups.every(group => group.values.length === 0)}
            >
              Continue to Summary
            </button>
          </div>
        </div>
      )}
      
      {step === 3 && (
        <div className="section-card">
          <h3 className="step-title">Step 3: Summary</h3>
          <p className="step-instruction">
            Below is a summary of your top values.
          </p>
          
          <div className="values-summary">
            {valueGroups.map((group, index) => (
              group.values.length > 0 && (
                <div key={index} className="value-group-summary">
                  <h4 className="group-name">{group.name}</h4>
                  <div className="group-values">
                    {group.values.join(', ')}
                  </div>
                </div>
              )
            ))}
          </div>
          
          <div className="final-message">
            <p>
              These value groups represent what's most important to you. Consider how you can align your daily actions and decisions with these core values for greater fulfillment and authenticity.
            </p>
          </div>
          
          <button 
            onClick={() => navigateToStep(2)}
            className="back-button"
          >
            Back to Step 2
          </button>
        </div>
      )}
    </section>
  );
};

export default ValuesSelection;